export const sponsorReduxActions = {
  GET_TEMPLATE_DATA_REQUEST: 'GET_SPONSORED_TRIAL_TEMPLATE_DATA_REQUEST',
  GET_TEMPLATE_DATA_SUCCESS: 'GET_SPONSORED_TRIAL_SPONSOR_TEMPLATE_DATA_SUCCESS',
  GET_TEMPLATE_DATA_FAILURE: 'GET_SPONSORED_TRIAL_SPONSOR_TEMPLATE_DATA_FAILURE',
  RESET_TEMPLATE_DATA: 'RESET_SPONSORED_TRIAL_SPONSOR_TEMPLATE_DATA',
};
